import { styled } from '@mui/material';
import theme from '../../../themes/theme';

export const ContainedPage = styled('div')(() => ({
  maxWidth: theme.breakpoints.values.lg,
  margin: 'auto',
  padding: theme.spacing(2, 2, 3),
}));

export const PageContentContainer = styled('div')(() => ({
  maxWidth: theme.breakpoints.values.lg,
  margin: 'auto',
  padding: theme.spacing(0, 2, 0),
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 2),
  },
}));
